import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function ProtectedRoute({ children, role }) {
    const { user } = useApp();
    if (user === null) {
        return (
            <div className="h-screen w-screen grid place-items-center text-sm text-neutral-500">
                Loading…
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (role && user.role !== role) return <Navigate to="/workflow" replace />;
    return children;
}
